import { render, staticRenderFns } from "./sp-item.vue?vue&type=template&id=52728552&scoped=true&"
import script from "./sp-item.vue?vue&type=script&lang=ts&"
export * from "./sp-item.vue?vue&type=script&lang=ts&"
import style0 from "./sp-item.vue?vue&type=style&index=0&id=52728552&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52728552",
  null
  
)

export default component.exports